<template>
  <div class="login_wrapper">
    <div class="login_cont">
      <h1></h1>
        <div class="login_form">
          <div class="form_row">
            <img :src="require('@/assets/newStyle/images/user_icon.png')" />
            <input type="text" v-model="loginForm.username" class="ipt_txt" placeholder="请输入您的用户名"/>
          </div>
          <div class="form_row">
            <img :src="require('@/assets/newStyle/images/paw_icon.png')" />
            <input type="password" v-model="loginForm.password" class="ipt_txt" placeholder="请输入您的密码"/>
          </div>
          <div class="form_btn">
            <button class="f_btn btn_dl" @click="handleLogin">登录</button>
            <button class="f_btn btn_zc" @click="currentRegister">注册</button>
          </div>
          <a class="sdl_link" @click="provinceLogin">
            省政务网用户登录
          </a>
        </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { checkDataType } from '@/utils/index.js'
  import variableStyle from '@/styles/variable.scss'
  import { LOGIN_URL, LOGIN_URL_BACK } from "@/store/mutation-types";

  export default {
    name: "Login",
    computed: {
      ...mapGetters({
        userInfo: "getUserInfo",
      }),
    },
    data() {
      return {
        variableStyle: variableStyle,
        /* 切换 */
        activeType: "1",
        codeUrl: "", // 手机号登录时的图形验证码
        isCodeLogin: false, // 个人账号时 是否扫码登录,true则显示二维码或小程序码false
        isShowWxQrCode: true, // true则显示小程序码 false则显示二维码，上线后应该不要二维码了
        // 二维码登录的
        qrCodeUrl: "", // 二维码URL
        qrCodeStatus: "", // 已生成 generated 已扫描 Scanned  已登录 Signed  已作废 invalid
        qrKey: "", // 用这个key来轮询
        // 小程序码登录
        wxQrCodeUrl: "",

        loginForm: {
          phone: "13798580884",
          code: "654321",
          uuid: '', // 图形验证码UUID
          captchaCode: '', // 图形验证码
          username:'',
          password:'',
        },
        loginRules: {
          username: [
            { required: true, trigger: "blur", message: "请输入您的账号" },
          ],
          password: [
            { required: true, trigger: "blur", message: "请输入您的密码" },
          ],
          phone: [
            { required: true, trigger: "blur", message: "请输入您的手机号码" },
          ],
          captchaCode: [
            { required: true, trigger: "blur", message: "请输入图形验证码" },
          ],
          code: [
            { required: true, trigger: "blur", message: "请输入短信验证码" },
          ],
        },
        loading: false,
        enterpriseList: [], // 是否有多家企业
        dialogVisible: false, // 弹窗选择哪一家企业来登录
        roleDialogLoading: false, // 多角色弹窗loading状态位
        // 短信验证码
        msgCodeInfo: {
          timer: null, // 计时器
          second: 60, // 计时时间
        },
        qrLoginInfo: {}, // 扫码登录返回的信息
      };
    },
    methods: {
      provinceLogin(){
        let pathname = window.location.host;
          let url =
            LOGIN_URL +
            "?refer=cp&backUrl=" +
            LOGIN_URL_BACK +
            "?targetUrl=" +
            pathname;
        window.location.href = url;
      },
      currentRegister(){
        this.$router.push({
          path: "/register2",
        });
      },
      provinceRegister(){
        let href = "https://login.hnzwfw.gov.cn/tacs-uc/corp/register";
        window.open(href, "_blank");
      },
      toggleCodeLogin() {
        this.isCodeLogin = !this.isCodeLogin;
        if (this.isCodeLogin) {
          this.getQrCode();
          this.openInterval();
        } else {
          this.clrInterval();
        }
      },
      refreshCode() {
        // 刷新二维码
        this.qrCodeStatus = "";
        this.getQrCode();
        this.openInterval();
      },
      refreshWxCode() {
        // 刷新小程序码
        this.wxQrCodeStatus = "";
        this.getWxQrCode();
        this.openInterval();
      },
      clrInterval() {
        // 清除定时器
        if (this.qrInterval) {
          clearInterval(this.qrInterval);
          this.qrInterval = null;
        }
      },
      openInterval() {
        // 打开定时器获取状态
        this.clrInterval();
        if (!this.isCodeLogin) {
          return;
        }
        this.qrInterval = setInterval(() => {
          this.getQRStatus();
        }, 1500);
      },
      async handleLogin() {
        let that = this;
        let valid = false;
        if(this.loginForm.username && this.loginForm.password){
          valid = true;
        }else{
          this.$message.error('请填写完整登录信息！')
        }
        if (valid) {
          let params = {
            username: this.loginForm.username,
            password: this.loginForm.password,
          };
          //let multiRole = await this.$httpApi.post('/dev-api/sms/getLoginEnterprise', params)
          let multiRole = await this.$httpApi.post('/dev-api/lhsso/loginLocalUser', params)
          console.log('multiRole:', multiRole)
          if(multiRole.topbrasses.length > 0){
            console.log('企业名字', multiRole.topbrasses[0].enterprise);
            console.log('统一社会信用代码', multiRole.topbrasses[0].tyshxydm);
          }else{
            console.log('没有值');
          }

          if (multiRole.code == 200) {
            if (!multiRole.topbrasses.length) {
              this.$message.error('错误：用户信息缺失，请联系管理员')
              // this.loading = false
              return
            }

            this.enterpriseList = multiRole.topbrasses
            if (this.enterpriseList.length === 1) {
              this.login(this.enterpriseList[0])
            } else {
              this.dialogVisible = true
            }
          } else {
            this.$message.error(`错误：${multiRole.msg}`)
            // this.loading = false
          }

        }else{

        }


      },
      /**
       * @description 登录
       * @param {Object} role 角色信息
       */
      login(role,targetUrl) {
        let params = {
          phone: role.phone,
          userId: role.userId,
        }
        console.log('登录的paramsxin',params);
        this.$httpApi.post('/dev-api/sms/login', params).then(res => {
          console.log('二次返回的至：',res)
          if (res.code == 200) {
            if (res.userInfo) {
              let temp_userInfo = JSON.parse(JSON.stringify(res.userInfo.sysUser))
              temp_userInfo.enterpriseList = this.enterpriseList
              temp_userInfo.enterpriseInfo = JSON.parse(JSON.stringify(role))
              temp_userInfo.tyshxydm = role.tyshxydm
              temp_userInfo.enterpriseInfo.logoId = res.userInfo.user?.logo
              sessionStorage.setItem('titleType',1)
              sessionStorage.setItem('isFirst',"true");
              this.$store.commit('updateToken', res.token)
              this.$store.commit("updateUserInfo", temp_userInfo)
              sessionStorage.setItem("titleType", 1);
              window.location.href='/'

            }
          }
        }).catch(err => {
          console.log('login error:', err)
        })
      },
      /**
       * @description 选择角色
       * @param {Object} role 角色信息
       */
      selectRole(role) {
        /**
         * 20210628
         * 区分 扫码登录/账号登录
         * 扫码登录，选择后直接保存信息
         * 账号登录，选择后还需调用登录接口
         */
        if (this.activeType == 1) {
          let token = this.qrLoginInfo.token
          let sysUser = this.qrLoginInfo.userInfo?.sysUser
          if (token && sysUser) {
            sysUser.enterpriseList = this.enterpriseList
            sysUser.enterpriseInfo = role
            sysUser.tyshxydm = role.tyshxydm

            this.$store.commit('updateToken', token)
            this.$store.commit("updateUserInfo", sysUser)
            this.jumpToPage()
          } else {
            this.$message.error('错误：用户信息缺失，请联系管理员')
            return
          }
        } else {
          this.roleDialogLoading = true
          this.login(role)
        }
      },

      jumpToPage() {
        this.dialogVisible = false
        this.$message({
          message: "登录成功",
          type: "success",
        });
        setTimeout(() => {
          this.loading = false;
          let targetStr = this.$router.history.current.path;
          if (["/register", "/login"].indexOf(targetStr) !== -1) {
            /**
             * 20210527
             * 配合小程序端复制链接直接进入政策申报页面
             * 如果未登录且重定向到登录页时，登录后应该直接返回
             */
            if (this.$route.query.back) {
              this.$router.replace(this.$route.query.back)
            } else {
              this.$router.replace({
                path: "/home",
              });
            }
          } else {
            this.$router.go(-1);
          }
        }, 1000);
      },
      getUserInfo() {
        this.$httpApi
          .get(
            "/dev-api/getInfo" +
            "?appid=afc903d9d5e449488a3cf9a00c3d1294&appkey=8cb4f61b-e89a-405b-acc8-4d992826c247",
            {}
          )
          .then((res) => {
            // console.log("信息getInfo: ", res);
            if (res.code === 200 && res.data) {
              let baseInfo = res.data.baseInfo;
              if (baseInfo != null) {
                this.$store.commit("updateAccountBaseInfo", baseInfo);
              }

              let userInfo = res.data.userInfo || {};
              /**
               * 20210506
               * 元林优化了 账号密码登录后这个接口返回的用户信息
               * 补了最关键的 userId用户ID 和 tyshxydm统一社会信用代码
               * 参考 扫码登录后整理的数据格式，这边也统一处理
               */
              userInfo.topbrass = res.data.topbrass || {};
              userInfo.userId = userInfo.topbrass.userId; // 用户ID
              userInfo.username = userInfo.loginId; // 用户账号(手机号码)
              userInfo.nickName = userInfo.name; // 用户昵称
              userInfo.sex = userInfo.topbrass.sex; // 性别
              userInfo.tyshxydm = userInfo.topbrass.tyshxydm; // 统一社会信用代码

              // console.log("信息userInfo", userInfo);
              // 判断是哪种类型账号 （公司账号信息必有社会信用代码，以此为判断条件）
              // if (userInfo.shxydm) {
              //   this.userType = 0;
              // } else {
              //   this.userType = 1;
              // }
              let mid = {
                icon:
                  "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
                userStatus: "已经绑定账号", // 用户是否绑定账号状态
                emailStatus: "未绑定邮箱", // 邮箱状态
                security: "1", // 安全等级 0 1 2
              };
              Object.assign(userInfo, mid);
              // userInfo.shxydm = baseInfo.shxydm;
              this.$store.commit("updateUserInfo", userInfo);
            }
          })
          .catch((err) => { });
      },
      getSmsCode() {
        if (!this.loginForm.phone) {
          this.$message("请先填写手机号");
          return;
        }

        let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!reg.test(this.loginForm.phone)) {
          this.$message("请输入正确的手机号");
          return;
        }
        /**
         * 20210601
         * 获取短信验证码时，把图形验证码的信息带上
         */
        if (!this.loginForm.uuid) {
          this.$message("错误，无效的图形验证码，请刷新")
          return
        }
        if (!this.loginForm.captchaCode) {
          this.$message("请先填写图形验证码")
          return
        }

        const loading = this.$loading({
          lock: true,
          text: "正在获取验证码",
          spinner: "el-icon-loading",
          target: this.$refs.loginContainer,
        });
        this.$httpApi
          .get("/dev-api/sms/getVerCode", {
            phone: this.loginForm.phone,
            uuid: this.loginForm.uuid,
            captchaCode: this.loginForm.captchaCode,
          })
          .then((res) => {
            this.$nextTick(() => {
              loading.close()
            })
            if (res.code == 200) {
              this.$message.success('验证码已发送')
              this.msgCodeInfo.timer = setInterval(() => {
                if (--this.msgCodeInfo.second === 0) {
                  clearInterval(this.msgCodeInfo.timer)
                  this.msgCodeInfo.timer = null
                  this.msgCodeInfo.second = 60
                }
              }, 1000)
            } else {
              this.$message.error(`错误：${res.msg}`)
            }
          })
          .catch((err) => {
            console.log("Err:", err);
            this.$message("网络异常，请稍后重试");
            this.$nextTick(() => {
              loading.close()
            })
          });
      },
      /**
       * @description 获取图形验证码
       * 获取验证码的方法
       */
      getCodeImg() {
        this.$httpApi
          .get("/dev-api/captchaImage", {})
          .then((res) => {
            // console.log("graphCode:", res)
            if (res.code === 200) {
              this.codeUrl = "data:image/gif;base64," + res.img;
              this.loginForm.uuid = res.uuid;
            }
          })
          .catch((err) => { });
      },
      getQrCode() {
        if (this.isShowWxQrCode) {
          // 获取小程序码
          this.$httpApi
            .post("/dev-api/authorizedLogin/getAuthorizedWeixinQr", {
              path: "pagesA/applyToManager/face_verify", //扫小程序码后跳转到小程序到这个face_verify页面
              scene: "oNQIq4_qrvxyk_yRVcOC0uGpX4aw", // 可以是传到小程序到参数，看需要传什么数据到小程序就用json字符串传
            })
            .then((res) => {
              console.log("getAuthorizedWeixinQr", res);
              if (res.code === 200) {
                this.wxQrCodeUrl = "data:image/gif;base64," + res.data.QR;
                this.qrKey = res.data.qrKey;
                console.log("获取的qrKey:", this.qrKey)
              }
            })
            .catch((err) => { });
        } else {
          // 获取二维码
          this.$httpApi
            .get("/dev-api/authorizedLogin/getAuthorizedQr", {})
            .then((res) => {
              console.log("getQrCode", res);
              if (res.code === 200) {
                this.qrCodeUrl = "data:image/gif;base64," + res.data.QR;
                this.qrKey = res.data.qrKey;
              }
            })
            .catch((err) => { });
        }
      },
      getQRStatus() {
        this.$httpApi
          .get(`/dev-api/authorizedLogin/getQRStatus?qrKey=${this.qrKey}`)
          .then((res) => {
            // 不停的去获取二维码状态，枚举值 // 已生成 generated 已扫描 Scanned  已登录 Signed
            // 当不是generated的时候说明已经失效了 需要重新生成
            console.log("==> getQRStatus", res);
            if (res.code === 200) {
              this.qrCodeStatus = res.data.qrStatus;
              if (this.qrCodeStatus == "Signed") {
                this.clrInterval();
                this.$message({
                  message: "登录成功",
                  type: "success",
                });
                /**
                 * 20210513
                 * 扫码登录的话，用户信息直接在扫码返回的信息中获取
                 * 暂不再去调用 getUserInfo
                 */
                this.qrLoginInfo = JSON.parse(JSON.stringify(res.data))
                this.enterpriseList = this.qrLoginInfo.userInfo?.topbrass || []
                if (!this.enterpriseList.length) {
                  this.$message.error('错误：用户信息缺失，请联系管理员')
                  return
                }
                if (this.enterpriseList.length === 1) {
                  let token = this.qrLoginInfo.token
                  let sysUser = this.qrLoginInfo.userInfo?.sysUser
                  if (token && sysUser) {
                    sysUser.enterpriseList = this.enterpriseList
                    sysUser.enterpriseInfo = this.enterpriseList[0]
                    sysUser.tyshxydm = this.enterpriseList[0].tyshxydm

                    this.$store.commit('updateToken', token)
                    this.$store.commit("updateUserInfo", sysUser)
                    this.jumpToPage()
                  } else {
                    this.$message.error('错误：用户信息缺失，请联系管理员')
                    return
                  }
                } else {
                  this.dialogVisible = true
                }
                let token = res.data.token;
                let userInfo = res.data.userInfo || {};
                let sysUser = userInfo.sysUser || {};
                sysUser.enterpriseInfo = userInfo.topbrass;
                if (sysUser.enterpriseInfo) {
                  sysUser.tyshxydm = sysUser.enterpriseInfo.tyshxydm;
                }
                if (token) {
                  this.$store.commit("updateToken", token);
                }
                this.$store.commit("updateUserInfo", sysUser);
                // this.getUserInfo()

                setTimeout(() => {
                  this.loading = false;
                  let targetStr = this.$router.history.current.path;
                  if (["/register", "/login"].indexOf(targetStr) !== -1) {
                    /**
                     * 20210527
                     * 配合小程序端复制链接直接进入政策申报页面
                     * 如果未登录且重定向到登录页时，登录后应该直接返回
                     */
                    if (this.$route.query.back) {
                      this.$router.replace(this.$route.query.back)
                    } else {
                      this.$router.replace({
                        path: "/home",
                      });
                    }
                  } else {
                    this.$router.go(-1);
                  }
                }, 1000);
              }
            } else {
              this.clrInterval();
            }
          })
          .catch((err) => {
            this.clrInterval();
          });
      },
      toRegister() {
        this.$router.replace({
          path: "/register",
        });
      },
      /**
       * 切换状态，修改status 值
       */
      // activeClick(tab, event) {
      //     console.log(this.activeType);
      //     this.loginForm.status = tab.name;
      //     if (this.activeType == 0) {
      //         this.clrInterval();
      //     } else if (this.isCodeLogin) {
      //         this.openInterval();
      //     }
      // },
      /**
       * 找回密码
       */
      retrievePwd() {
        this.$router.push({
          path: "/findPwd?activeType=" + this.activeType,
        });
      },
    },
    created() {
      if (this.$route.query.user) {
        this.loginForm.username = this.$route.query.user;
      }
      this.getCodeImg()
    },
    mounted() {
      if (this.loginForm.phone === "") {
        this.$refs.phone.focus();
      }
      /**
       * 20210524
       * 优先显示扫码登录，且配合 首页二维码登录快捷入口
       * 页面挂载完，再启动定时器
       */
      if (this.isCodeLogin) {
        this.getQrCode()
        this.openInterval()
      } else {
        this.clrInterval()
      }
    },
    beforeDestroy() {
      this.clrInterval();
      clearInterval(this.msgCodeInfo.timer)
    },
  };
</script>
<style lang="scss" scoped>
@import "@/assets/newStyle/css/login.scss";
.login_wrapper{
  height: 100vh;
}

</style>
